"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FALLBACK_CDNS = void 0;
exports.FALLBACK_CDNS = [
    'cdn-static.ap4r.com',
    'g-static.ap4r.com',
];
